module.exports = require("./build/ec-button.js");


//////////////////
// WEBPACK FOOTER
// ec-button (bower component)
// module id = 17
// module chunks = 0